import React, { useId } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import styles from './totalCountField.module.scss';

// Ukupan broj stavki u tabeli (labela + onemoguceno polje), za traku filtera
// iznad tabele - prosledjuje se kao rightHeaderActions u TableSection.
const TotalCountField = ({ label, count, loading = false }) => {
  const id = useId();

  return (
    <div className={styles.totalCount}>
      <label htmlFor={id} className={styles.totalCount__label}>
        {label}
      </label>
      <Input
        id={id}
        disabled
        className={styles.totalCount__input}
        value={count ?? (loading ? '...' : 0)}
      />
    </div>
  );
};

TotalCountField.propTypes = {
  label: PropTypes.string.isRequired,
  count: PropTypes.number,
  loading: PropTypes.bool,
};

export default TotalCountField;
